import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import ListState from '../states/list.state';
import { fetchTubModels } from '../actions/tubModels.actions';

const initialState: ListState = {
  loading: false,
  data: [],
  error: null,
  meta: null,
};

const tubModelsSlice = createSlice({
  name: 'tubModels',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
    // Fetch all tub models
      .addCase(fetchTubModels.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTubModels.fulfilled, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.data = action.payload.data;
        state.meta = action.payload.meta;
      })
      .addCase(fetchTubModels.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload ?? null;
      });
    }
});

export default tubModelsSlice.reducer;